/* src/app/modules/expense-reports/components/report-review/report-totalizer/report-totalizer.component.scss */
@media (max-width: 575.98px) {
  table {
    font-size: 0.95rem;
  }
  .form-label-sm {
    font-size: 0.9rem;
  }
}
/*# sourceMappingURL=report-totalizer.component.css.map */
